import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


import { IBreadcrumb } from '../../models';


@Component({
	selector: 'layout-breadcrumb-item',
	templateUrl: './breadcrumb-item.component.html',
	imports: [TranslateModule]
})
export class BreadcrumbItemComponent {
	@Input() item: IBreadcrumb;
}
